import { useTranslation } from "react-i18next";

import ConfirmDialog from "../../components/ui/confirmDialog";

interface FraudWarningModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
}

// "CAPS Warning - Potential Fraud" popup (SVRS-57313), shown when Informed's
// fraud verdict flips false -> true during a review session. Continue takes
// the analyst to the normal Exit the Account screen; Return to Account (or
// dismissing the dialog) just closes it and leaves the analyst in the
// Workbench — nothing has been saved or moved at this point.
function FraudWarningModal({ open, onOpenChange, onContinue }: FraudWarningModalProperties) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("fraudWarning.heading")}
      description={t("fraudWarning.message")}
      maxWidthClassName="max-w-md"
      variant="warning"
      cancelAction={{ label: t("fraudWarning.returnToAccount") }}
      confirmAction={{ label: t("fraudWarning.continue"), onClick: onContinue }}
    />
  );
}

export default FraudWarningModal;
